import { render, staticRenderFns } from "./InsuranceProducts.vue?vue&type=template&id=679c1de2&"
import script from "./InsuranceProducts.vue?vue&type=script&lang=js&"
export * from "./InsuranceProducts.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceProducts.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports